<template>
  <div class="app-container">
    <navigation :title="headerTitle"></navigation>
    <div class="list">
      <van-cell is-link v-for="item in list" :to="{name:'openTime', query: {id:item.id, title:item.title}}" center>
        <template #title>
          <img :src="baseUrl+item.iconPath" class="guide-list-icon" v-if="item.iconPath">
          <span class="custom-title">{{ item.title }}</span>
        </template>
      </van-cell>
    </div>
    <version></version>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Tabbar, TabbarItem, NavBar, Cell, CellGroup } from 'vant'
  import {request} from '../../untils/request'
  import navigation from '../../components/navigation'
  import version from '../../components/version'

  Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Cell).use(CellGroup)

  export default {
    name: 'guideLevel',
    components: {navigation, version},
    data () {
      return {
        baseUrl: process.env.API_ROOT,
        list: [],
        headerTitle:this.$route.query.title
      }
    },
    created () {
      // 指南列表
      this.getList()
    },
    methods: {
      getList () {
        var params = {
          readerGuideId: this.$route.query.id
        }
        request('post', '/nlc-web/api/readerGuide/info', params).then(res => {
          console.log('目录', res)
          this.list = res.data.childNode
        })
      }
    }
  }
</script>

<style scoped>
  .app-container{
    height:100%;
    background:#ecf5fd;
    overflow-y:scroll;
    min-height: calc(100% - .92rem);
    position:absolute;
    left:0;
    top:0;
  }
  .tip{
    color:#C9CBCD;
    text-align:center;
    font-size:.2rem;
    padding:.25rem 0;
    line-height:.2rem;
    font-family: SourceHanSansCN-Light;
  }
  .list{
    width:6.94rem;
    margin:1.18rem .27rem 0 .29rem;
    background:#fff;
    border-radius:8px;
  }
  .van-cell--clickable{
    height:1rem;
  }
  .van-cell::after{
    border-bottom: 1px solid #B3BBC3;
  }
  .van-cell{
    border-radius:8px;
  }
  .guide-list-icon {
    width: .28rem;
    height: .28rem;
    vertical-align: middle;
  }
  .custom-title{
    font-size:.28rem;
    font-family: SourceHanSerifCN-Medium;
  }
</style>



// WEBPACK FOOTER //
// src/view/guideLevel/index.vue